import { render, staticRenderFns } from "./DescargarArchivo.vue?vue&type=template&id=4710b394"
import script from "./DescargarArchivo.vue?vue&type=script&lang=js"
export * from "./DescargarArchivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports